<template>
    <div>

    </div>
</template>

<script>
export default {
    name: "music-con",
    props: {
        musicUrl: {
            type: String,
            default() {
                return null
            }
        }
    }
}
</script>

<style scoped>

</style>
